var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Prop, Component, CustomElement, Watch, svg, unsafeHTML } from '@sick-davinci/ce-decorators';
import { style } from './Icon.style';
const emptySVG = '<svg></svg>'; // tslint:disable: max-line-length

/**
 * A `davinci-icon-ref` displays a svg as icon.
 *
 * @example
 * ```html
 * <davinci-icon-ref
 *    src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z'/%3E%3C/svg%3E"
 *    style="fill: aquamarine">
 * </davinci-icon-ref>
 * ```
 */

export let IconRef = (_dec = Component({
  tag: 'davinci-icon-ref',
  style: [style]
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Watch('src'), _dec5 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = class IconRef extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "src", _descriptor, this);

    _defineProperty(this, "_iconCache", emptySVG);
  }

  render() {
    return svg`${unsafeHTML(this._iconCache)}`;
  }

  srcWatcher(_, newValue) {
    this._iconCache = emptySVG;

    if (newValue.startsWith('<svg')) {
      this._iconCache = newValue;
    } else if (newValue.startsWith('data:')) {
      const svgString = newValue.split(',');

      if (svgString.length > 1) {
        if (newValue.indexOf(';base64') >= 0) {
          svgString[1] = atob(svgString[1]);
        }

        const rawSVG = decodeURI(svgString[1]);

        if (rawSVG.startsWith('<svg')) {
          this._iconCache = rawSVG;
        }
      }
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "src", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "srcWatcher", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "srcWatcher"), _class2.prototype)), _class2)) || _class);
